<div style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<span fxFlex="85">
		<h2 mat-dialog-title style="margin-bottom: 0px">{{data.carrierBusinessName}}</h2>
	</span>
</div>

<div class="primary-light-color" style="font-weight: normal; padding: 1.5rem 1.5rem 0px 1.5rem">
	<div *ngIf="accountSettings.FREQUENCY_ENABLED" fxLayout="row">
		<div fxFlex>
			Frequency: {{!utilService.isNullOrUndefined(data.frequency) ? data.frequency : '' }}
		</div>
		<div fxFlex fxLayoutAlign="center start">DH-O: {{data.originDeadhead | number:'1.2-2'}}</div>
		<div fxFlex></div>
	</div>

	<div [ngClass]="{ 'p-t-1': accountSettings.FREQUENCY_ENABLED }" fxLayout="row">
		<div class="font-size-17" fxFlex><b>HQ: {{data.carrierHQ}}</b></div>

		<div class="font-size-17" fxFlex fxLayoutAlign="center start">
			<b>DH-D: {{data.destinationDeadhead | number:'1.2-2'}}</b>
		</div>

		<app-mc-dot-flip-animation [dot]="data.dot" [mc]="data.mc"></app-mc-dot-flip-animation>

		<div
			*ngIf="utilService.isNullOrUndefined(data.mc) && utilService.isNullOrUndefined(data.dot)"
			fxFlex
		></div>
	</div>

	<div class="p-t-1" fxLayout="row">
		<div fxFlex>Trucks: {{data.powerUnits}}</div>
		<div fxFlex fxLayoutAlign="center start">Drivers: {{data.drivers}}</div>
		<div fxFlex fxLayoutAlign="end end">
			Main #:
			<a
				*ngIf="!utilService.isNullOrUndefined(data.phone) && data.phone.length > 0"
				href="tel:{{data.phone}}"
			>
				{{(data.phone | mask: '(000) 000-0000') }} {{ data.phone.split(';')[1] != undefined &&
				data.phone.split(';')[1] != null ? (' ext. ' + data.phone.split(';')[1]) : ''}}
			</a>
		</div>
	</div>
</div>

<mat-dialog-content style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div>
		<h3 style="font-weight: 100">Representatives</h3>
	</div>

	<div>
		<div>
			<app-carrier-contacts
				[carrierId]="this.data.carrierId"
				[carrier]="null"
				[contactList]="contactList"
				[editPrimaryContact]="data.editPrimaryContact"
				[isCarrierProfile]="true"
				[oldCarrierId]="null"
			>
			</app-carrier-contacts>
		</div>

		<div *ngIf="!contactList?.length" fxLayout="row" fxLayoutAlign="top left" fxLayoutGap="1rem">
			<div fxFlex="100" fxLayoutAlign="center center">
				<h5>No contacts available.</h5>
			</div>
		</div>

		<div *ngIf="data.isFeedbackEnabled && USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN" fxLayout="row">
			<app-carrier-contacts-feedback
				(emitUserResponse)="allQuestionsAnswered($event)"
				[capacitySearch]="capacitySearch"
				fxFlex="100"
			></app-carrier-contacts-feedback>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions style="padding: 1.5rem 1.5rem 1rem 1.5rem; margin: 1px">
	<div
		*ngIf="!data.isFeedbackEnabled || USER_ACCOUNT_TYPE == ACCOUNT_TYPE.ADMIN "
		fxFlex="100"
		fxLayoutAlign="end end"
	>
		<button (click)="closeDialog()" color="primary" mat-raised-button>Done</button>
	</div>

	<div
		*ngIf="data.isFeedbackEnabled && USER_ACCOUNT_TYPE != ACCOUNT_TYPE.ADMIN"
		fxFlex="100"
		fxLayoutAlign="end end"
	>
		<div fxFlex>
			<app-account-mapping
				(customerCarrierUpdated)="isCustomerCarrierUpdated = true; data.isCustomerCarrier = $event;"
				[carrierId]="data.carrierId"
				[isCustomerCarrier]="data.isCustomerCarrier"
			></app-account-mapping>
		</div>
		<div fxFlex="18" fxLayoutAlign="end end">
			<button
				(click)="submitFeedback()"
				*ngIf="userResponseSegmentPayload != null"
				color="primary"
				mat-raised-button
			>
				Done
			</button>
		</div>
	</div>
</mat-dialog-actions>
